document.addEventListener("DOMContentLoaded", function () {
  var wishlistKey = "wishlist";
  var e = JSON.parse(localStorage.getItem(wishlistKey)) || [];
  e = Array.isArray(e) ? e.map(function (t) {
    var x = {};
    for (var k in t) { x[k] = t[k]; }
    x.id = t.id.toString();
    return x;
  }) : [];

  var s = document.querySelectorAll(".wish-buttons-container");
  var wishlistGrid = document.getElementById("wishlist-grid");
  var emptyMessage = document.getElementById("empty-message");

  function updateCount() {
    var t = document.getElementById("wish-count");
    if (t) {
      t.textContent = e.length + " item" + (1 !== e.length ? "s" : "") + " 📦 in wishlist";
    }
  }

  function showNotification(msg) {
    var notif = document.querySelector(".wishlist-notification");
    if (notif) {
      var notifMsg = notif.querySelector("#notification-message");
      if (notifMsg) notifMsg.textContent = msg;
      notif.classList.add("active");
      setTimeout(function () {
        notif.classList.remove("active");
      }, 5000);
    }
  }

  function renderWishlist() {
    var s = document.getElementById("wishlist-grid");
    var r = document.getElementById("empty-message");
    if (s) {
      s.innerHTML = "";
      if (e.length === 0) {
        if (r) r.style.display = "block";
        s.style.display = "none";
      } else {
        if (r) r.style.display = "none";
        s.style.display = "grid";
        e.forEach(function (r) {
          var a = document.createElement("div");
          a.className = "wish-item";
          var d = r.image ? "https://carauana.com/cdn/shop/" + r.image : "https://via.placeholder.com/200";
          a.innerHTML =
            '<img src="' + d + '" alt="' + r.title + '">' +
            "<h2>" + r.title + "</h2>" +
            "<h3>$" + r.price + "</h3>" +
            '<a href="' + r.url + '" class="btn-wish-style">👀 View Product</a>' +
            '<button class="remove-wish-button btn-wish-style" data-product-id="' + r.id + '">🚫 Remove</button>';
          s.appendChild(a);
          var btn = a.querySelector(".remove-wish-button");
          if (btn) {
            btn.addEventListener("click", function () {
              var pid = this.getAttribute("data-product-id");
              e = e.filter(function (t) { return t.id !== pid; });
              localStorage.setItem(wishlistKey, JSON.stringify(e));
              updateCount();
              renderWishlist();
              showNotification("1 item was ❌ removed from your wishlist");
            });
          }
        });
      }
    }
  }

  for (var si = 0; si < s.length; si++) {
    var container = s[si];
    var r = container.getAttribute("data-product-id");
    var a = container.getAttribute("data-product-title");
    var d = container.getAttribute("data-product-price");
    var l = container.getAttribute("data-product-image");
    var c = container.getAttribute("data-product-url");
    var m = container.querySelector(".wish-button");
    if (!m) continue;
    var h = m.querySelector(".lord-icon");
    var u = m.querySelector(".wish-tooltiptext");

    var alreadyInWishlist = false;
    for (var je = 0; je < e.length; je++) {
      if (e[je].id === r) { alreadyInWishlist = true; break; }
    }
    if (alreadyInWishlist && h && u) {
      h.classList.add("wish-added");
      h.classList.remove("wish-add");
      h.setAttribute("state", "morph-two-hearts");
      h.setAttribute("trigger", "loop-on-hover");
      h.setAttribute("delay", "1000");
      h.setAttribute("colors", "primary:#ee66aa,quaternary:#ffffff");
      u.textContent = "✅ already in wishlist";
    }

    m.addEventListener("click", (function (prod) {
      return function () {
        var idx = -1;
        for (var je = 0; je < e.length; je++) {
          if (e[je].id === prod.id) { idx = je; break; }
        }
        var h = this.querySelector(".lord-icon");
        var u = this.querySelector(".wish-tooltiptext");
        if (idx > -1) {
          // Remove
          e = e.filter(function (t) { return t.id !== prod.id; });
          if (h) {
            h.classList.remove("wish-added");
            h.classList.add("wish-removed");
            h.setAttribute("state", "morph-heart-broken");
            h.setAttribute("trigger", "morph");
            h.setAttribute("colors", "primary:#e83a30,secondary:#ffffff");
          }
          if (u) u.textContent = "♥️ Add to wishlist";
          showNotification("1 item was ❌ removed from your wishlist");
        } else {
          // Add
          e.push({
            id: prod.id, title: prod.title, price: prod.price, image: prod.image, url: prod.url
          });
          if (h) {
            h.classList.remove("wish-removed");
            h.classList.add("wish-added");
            h.setAttribute("state", "morph-two-hearts");
            h.setAttribute("trigger", "loop");
            h.setAttribute("delay", "1000");
            h.setAttribute("colors", "primary:#ee66aa,quaternary:#ffffff");
          }
          if (u) u.textContent = "❌ Remove from wishlist";
          showNotification("✅ Added " + prod.title + " to your wishlist");
        }
        localStorage.setItem(wishlistKey, JSON.stringify(e));
        updateCount();
        renderWishlist();
      };
    })({
      id: r,
      title: a,
      price: d,
      image: l,
      url: c
    }));
  }

  var clearBtn = document.getElementById("clear-wishlist");
  if (clearBtn) {
    clearBtn.addEventListener("click", function () {
      e.length = 0;
      localStorage.setItem(wishlistKey, JSON.stringify(e));
      renderWishlist();
      updateCount();
      showNotification("🗑️Wishlist cleared");
    });
  }

  var shareBtn = document.getElementById("share-wishlist");
  if (shareBtn) {
    shareBtn.addEventListener("click", function () {
      var url = window.location.href;
      if (navigator.share) {
        navigator.share({ title: "My Wishlist", url: url }).catch(function (t) {
          console.log("Error sharing:", t);
        });
      } else {
        alert("Sharing is not supported on this device.");
      }
    });
  }

  var badge = document.querySelector(".wishlist-badge");
  if (badge) {
    badge.addEventListener("click", function () {
      window.open("/pages/wishlist", "_blank");
    });
  }
  updateCount();
  renderWishlist();
});

// Animazione bottone stile (come richiesto)
document.addEventListener("DOMContentLoaded", function () {
  var t = document.getElementById("btn-wish-style");
  if (t) {
    var e = t.textContent;
    t.innerHTML = "";
    e.split("").forEach(function (chr, idx) {
      var i = document.createElement("mix");
      i.textContent = chr;
      i.style.animationDelay = (0.1 * idx) + "s";
      t.appendChild(i);
    });
  }
});
